import type { BookingQuestionType } from '@shared/core/appointment-types'
import classNames from 'classnames'
import { ChevronDown } from 'lucide-react'
import type { ReactNode } from 'react'
import type { QuestionPreviewProps } from './question-preview.interface'
import classes from './question-preview.module.scss'

const DROPDOWN_PLACEHOLDER = 'Select one'

const CONTROL_BY_TYPE: Record<BookingQuestionType, (options: string[]) => ReactNode> = {
  short_text: () => <div className={classes.input} />,
  long_text: () => <div className={classNames(classes.input, classes.textarea)} />,
  dropdown: () => (
    <div className={classNames(classes.input, classes.select)}>
      {DROPDOWN_PLACEHOLDER}
      <ChevronDown size={14} strokeWidth={2.5} className={classes.chevron} />
    </div>
  ),
  multiple_choice: (options) => renderChoices(options, classes.radioMark),
  checkboxes: (options) => renderChoices(options, classes.checkboxMark),
}

export function QuestionPreview({ question }: QuestionPreviewProps) {
  const isChoiceList = question.type === 'multiple_choice' || question.type === 'checkboxes'
  return (
    <div className={classNames(classes.root, { [classes.choiceRoot]: isChoiceList })}>
      <div className={classes.label}>
        {question.label}
        {question.required && <span className={classes.required}> *</span>}
      </div>
      <div aria-hidden="true">{CONTROL_BY_TYPE[question.type](question.options ?? [])}</div>
    </div>
  )
}

function renderChoices(options: string[], markClassName: string) {
  return (
    <div className={classes.choices}>
      {options.map((option, index) => (
        <div key={`${index}-${option}`} className={classes.choice}>
          <span className={markClassName} />
          {option}
        </div>
      ))}
    </div>
  )
}
